import InputMask from 'react-input-mask'
import React, { useEffect, useState, useCallback } from 'react'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { useForm, Controller } from 'react-hook-form'
import axios from 'axios'
import styles from '../../listing/form/styles.module.scss'
import { toast } from 'react-toastify'
import parse from 'html-react-parser'
import { InvisibleSmartCaptcha } from '@yandex/smart-captcha'

const FormVacationPopup = ({ setSuccessForm2, setActiveForm, checkDomenNameState, captchaSiteKey }) => {
  const [mobile, setMobile] = useState('')
  const [errorMobile, setErrorMobile] = useState(false)
  const [success2, setSuccess2] = useState(false)
  const [blurSuccess, setBlurSuccess] = useState(false)
  const [file, setFile] = useState(null)
  const [blurFile, setBlurFile] = useState(false)
  const [checkResume, setCheckResume] = useState('')
  const [blurResum, setBlurResum] = useState(false)
  const [departaments, setDepartaments] = useState([])
  const [directions, setDirections] = useState([])
  let _protocol = window.location.protocol

  const [token, setToken] = useState('')
  const [visible, setVisible] = useState(false)
  const handleChallengeHidden = useCallback(() => setVisible(false), [])
  const handleButtonClick = () => setVisible(true)

  // const getAllDepartaments = async () => {
  //   try {
  //     const result = await axios({
  //       method: 'get',
  //       url: `${_protocol}//${checkDomenNameState}/api/v1/unit/names/all`
  //     })
  //     setDepartaments(result.data)
  //   } catch (e) {
  //     toast.error('Ошибка загрузки вакансий')
  //   }
  // }

  const getDirections = async () => {
    try {
      const result = await axios({
        method: 'get',
        url: `${_protocol}//${checkDomenNameState}/api/v1/unit/direction`
      })
      setDirections(result.data)
    } catch (e) {
      toast.error('Ошибка загрузки вакансий')
    }
  }


  const schemaIceForm2 = yup
    .object({
      FIO: yup
        .string()
        .matches(/^[а-яА-ЯёЁ]+([-][а-яА-ЯёЁ]+)?(\s[а-яА-ЯёЁ]+){1,2}$/, 'Неверный формат данных')
        .required('Это обязательное поле'),
      city: yup
        .string()
        .matches(
          /^(([a-zA-Zа-яА-ЯёЁ]*(\s*)\([a-zA-Zа-яА-ЯёЁ\s]*\))|([a-zA-Zа-яА-ЯёЁ\-0-9]*)|([a-zA-Zа-яА-ЯёЁ]+[-|\s]?[a-zA-Zа-яА-ЯёЁ]*[-|\s]?[a-zA-Zа-яА-ЯёЁ]*[-|\s]?[a-zA-Zа-яА-ЯёЁ]*))$/,
          'Неверный формат данных'
        )
        .required('Это обязательное поле'),
//      unitName: yup.string().required('Это обязательное поле'),
      unitDirection: yup.string().required('Это обязательное поле'),
      email: yup
        .string()
        .matches(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/, 'Неверный формат данных')
        .required('Это обязательное поле'),

      letter: yup.string().required('Это обязательное поле')
    })
    .required()

  // setting form - inputs
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors, isValid }
  } = useForm({
    mode: 'onSubmit',
    resolver: yupResolver(schemaIceForm2)
  })

  const onChanges = data => {
    let checkFIO = watch('FIO')
    let finallyFIO = []
    if (checkFIO) {
      finallyFIO = checkFIO.split(' ')
    }

    const obj = {
      positionId: null,
      positionName: null,
      firstName: finallyFIO[1],
      middleName: finallyFIO[2],
      lastName: finallyFIO[0],
      city: data.city,
      // unitName: data.unitName,
      phoneNumber: '' + mobile,
      email: data.email,
      link: data.resume,
      info: data.letter,
      course: null,
      faculty: null,
      department: null,
      unitDirection: data.unitDirection,
      university: null,
      nameEducation: null,
      type: 'COLD',
      token: token,
    }

    const json = JSON.stringify(obj)
    const blob = new Blob([json], {
      type: 'application/json'
    })

    let saveRequest = new FormData()
    saveRequest.append('saveRequest', blob)
    saveRequest.append('file', file)

    mobile.length < 18 && setErrorMobile(true)
    !file && setBlurFile(true)
    !success2 && setBlurSuccess(true)

    let _protocol = window.location.protocol

    if (
      mobile.length === 18 &&
      success2) {
      axios({
        method: 'post',
        url: `${_protocol}//${checkDomenNameState}/api/v1/response/save`,
        data: saveRequest,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then((response) => {
          if (response.data.status != "error") {

            // window._tmr = window._tmr || [];
            // window._tmr.push({ type: 'reachGoal', id: 3398932, goal: 'otpravit_zayavku'});

            setSuccessForm2(true)
            reset()
            setMobile('')
            setBlurFile(false)
            // eslint-disable-next-line no-undef
            ym(94755545,'reachGoal','vacancy_form_submit')
          } else {
            let _error = <>{parse(response.data.message)}</>
            toast.error(_error);
          }
        })
        .catch(() => {
          setSuccess2(false)
          toast.error('Отклик не отправился!')
        })
        .finally(() => {
          setSuccess2(false)
          setBlurSuccess(false)
          setErrorMobile(false)
        })
    }
  }
  let watchResume = watch('resume')
  useEffect(() => {
    setSuccessForm2(false)
    const regExpPhone = new RegExp('^(https?|ftp|file)://[-a-zA-Z0-9+&@#/%?=~_|!:,.;]*[-a-zA-Z0-9+&@#/%=~_|]')

    let total = ''
    if (watchResume) {
      total = regExpPhone?.test(watchResume)
    }
    setCheckResume(total)
//    getAllDepartaments()
    getDirections()

    if (watchResume) {
      setBlurResum(true)
    } else {
      setBlurResum(false)
    }
  }, [watchResume])

  return (
    <div>
      <form className={styles.form_block_listing_wrapper} onSubmit={handleSubmit(onChanges)}>
        <div className={errors.FIO?.message ? styles.form_block_listing_item_error : styles.form_block_listing_item}>
          <label htmlFor='FIO'>Фамилия, имя, отчество</label>
          <input
            {...register('FIO')}
            placeholder='Например, Иванов Иван Иванович'
            type='text'
            name='FIO'
            maxLength='50'
            className='placeholder-gray-400'
          />
          {errors?.FIO && <p className={styles.left_input_error}>{errors.FIO?.message}</p>}
        </div>

        <div className='flex justify-between max-lg:flex-col'>
          <div
            className={errors.city?.message ? styles.form_block_listing_item2_error : styles.form_block_listing_item2}
          >
            <label htmlFor='city'>Город</label>
            <input {...register('city')} placeholder='Например, Москва' type='text' name='city' className='placeholder-gray-400' />
            {errors?.city && <p className={styles.left_input_error}>{errors.city?.message}</p>}
          </div>

          {/*<div*/}
          {/*  className={*/}
          {/*    errors.unitName?.message ? styles.form_block_listing_item2_error : styles.form_block_listing_item2*/}
          {/*  }*/}
          {/*>*/}
          {/*  <label htmlFor='unitName'>Подразделение</label>*/}
          {/*  <select {...register('unitName')} name='unitName' className="placeholder-gray-400">*/}
          {/*    <option value=''>Выбрать подразделение</option>*/}
          {/*    {departaments &&*/}
          {/*      departaments.map(item => (*/}
          {/*        <option value={item} className={styles.input_select_option}>*/}
          {/*          {item}*/}
          {/*        </option>*/}
          {/*      ))}*/}
          {/*  </select>*/}
          {/*  {errors?.unitName && <p className={styles.left_input_error}>{errors.unitName?.message}</p>}*/}
          {/*</div>*/}
          <div
              className={
                errors.unitDirection?.message ? styles.form_block_listing_item2_error : styles.form_block_listing_item2
              }
          >
            <label htmlFor='unitDirection'>Направление</label>
            <select {...register('unitDirection')} name='unitDirection' className="placeholder-gray-400">
              <option value=''>Выбрать направление</option>
              {directions &&
                  directions.map(item => (
                      <option value={item} className={styles.input_select_option}>
                        {item}
                      </option>
                  ))}
            </select>
            {errors?.unitDirection && <p className={styles.left_input_error}>{errors.unitDirection?.message}</p>}
          </div>
        </div>

        <div className='flex justify-between max-lg:flex-col'>
          <div
            className={
              errorMobile && mobile?.length !== 18
                ? styles.form_block_listing_item2_error
                : styles.form_block_listing_item2
            }
          >
            <label htmlFor='telephone'>Телефон</label>
            <InputMask
              mask="+7 (999) 999-99-99"
              value={mobile}
              onChange={e => setMobile(e.target.value)}
              className="placeholder-gray-400"
              label="telephone"
              autoComplete="off"
              placeholder="Например, +7 (777) 777-77-77"
            >
            </InputMask>
            {errorMobile && mobile?.length !== 18 && <p className={styles.left_input_error}>Неверный формат номера</p>}
            {errorMobile && mobile?.length === 0 && <p className={styles.left_input_error}>Это обязательное поле</p>}
          </div>
          <div
            className={errors.email?.message ? styles.form_block_listing_item2_error : styles.form_block_listing_item2}
          >
            <label htmlFor='email'>Электронная почта</label>
            <input {...register('email')} placeholder='Например, example@example.com' type='email' name='email' className='placeholder-gray-400' />
            {errors?.email && <p className={styles.left_input_error}>{errors.email?.message}</p>}
          </div>
        </div>

        <div className={errors.file?.message ? styles.form_block_listing_file_error : styles.form_block_listing_file}>
          <label htmlFor='file'>Перетащите или загрузите файл резюме</label>
          <p>1 файл .pdf, .docx, .doc не более 5 Мб</p>
          <input type='file' accept='application/pdf, application/msword, application/vnd.oasis.opendocument.text, application/vnd.openxmlformats-officedocument.wordprocessingml.document' onChange={e => {setFile(e.target.files[0])}} className={[styles.file_input, 'placeholder-gray-400'].join(' ')} />
          {['application/pdf', 'application/msword', 'application/vnd.oasis.opendocument.text', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'].indexOf(file?.type) !== -1 && blurFile && file && (
            <p className={styles.left_input_error}>Неверный формат файла!</p>
          )}
          <p className={styles.left_input_file_name}>{file?.name}</p>
          {file?.size > 4999995 && blurFile && file && (
            <p className={styles.left_input_error}>Размер файла не более 5мб!</p>
          )}
          <div className={styles.file_clip}>
            <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.77121 2.74349C12.1127 0.399907 15.9117 0.399907 18.2548 2.74305C20.5379 5.02612 20.5964 8.69133 18.4304 11.0453L18.2423 11.2426L9.44224 20.0408L9.40567 20.0711C7.94443 21.3879 5.69043 21.3431 4.28306 19.9357C2.96404 18.6167 2.84193 16.554 3.91671 15.0973C3.94005 15.052 3.9683 15.0082 4.00152 14.9671L4.05507 14.9074L4.14198 14.8197L4.28306 14.6718L4.28598 14.6747L11.7217 7.22038C11.9876 6.95376 12.4043 6.929 12.6982 7.14646L12.7824 7.21897C13.049 7.48488 13.0738 7.90151 12.8563 8.19541L12.7838 8.27963L5.18917 15.8927C4.47153 16.7683 4.52141 18.0626 5.33881 18.88C6.16787 19.7091 7.48752 19.7485 8.36331 18.9984L17.196 10.168C18.9515 8.41031 18.9515 5.56107 17.1941 3.80371C15.4917 2.10127 12.7646 2.04807 10.9981 3.64411L10.8302 3.80371L10.8176 3.81802L1.28131 13.3543C0.988413 13.6472 0.51354 13.6472 0.220646 13.3543C-0.0456202 13.0881 -0.0698261 12.6714 0.148028 12.3778L0.220646 12.2937L9.76952 2.74305L9.77121 2.74349Z" fill="#212121"/>
            </svg>
          </div>
        </div>

        <div
          className={!checkResume && blurResum ? styles.form_block_listing_item_error : styles.form_block_listing_item}
        >
          <label htmlFor='resume'>Ваша ссылка на резюме</label>
          <input
            {...register('resume')}
            placeholder='Например, на HeadHunter, Superjob или Хабр Карьере'
            type='text'
            name='resume'
            className='placeholder-gray-400'
          />
          {!checkResume && blurResum && <p className={styles.left_input_error}>Неверная ссылка!</p>}
        </div>

        <div className={errors.letter?.message ? styles.form_block_listing_item_error : styles.form_block_listing_item}>
          <label htmlFor='letter'>Сопроводительное письмо</label>
          <input
            {...register('letter')}
            placeholder='Я хочу работать в Generium, потому что...'
            type='text'
            name='letter'
            maxLength='1000'
            className='placeholder-gray-400'
          />
          {errors?.letter && <p className={styles.left_input_error}>{errors.letter?.message}</p>}
        </div>
        <div
          className={
            !success2 && blurSuccess ? styles.form_block_listing_checkbox_error : styles.form_block_listing_checkbox
          }
        >
          <input onClick={() => {setSuccess2(!success2); handleButtonClick();}} type='checkbox' id='agreement2' name='agreemen2t' className={styles.agreement2} />
          <label htmlFor='agreement2'></label>
          <p>
            Я даю согласие на{' '}
            <a href='/privacy-policy' target='_blank'>
              <span onClick={() => setActiveForm(false)}>обработку моих персональных данных</span>
            </a>{' '}
          </p>
          {success2 === false && blurSuccess === true && (
            <p className={styles.left_input_error}>Эта галочка обязательна!</p>
          )}
        </div>

        <InvisibleSmartCaptcha
          sitekey={captchaSiteKey}
          onSuccess={setToken}
          onChallengeHidden={handleChallengeHidden}
          visible={visible}
        />

        <button
          className={styles.form_block_listing_btn_active}
        >
          Отправить заявку
          <span>&rarr;</span>
        </button>
      </form>
    </div>
  )
}

export default FormVacationPopup
